import apiService from './api-service';

export const logService = {
	getLogsByFilters
};

async function getLogsByFilters(beginTime, endTime, userId, logType) {
	const options = [
		{
			name: "beginTime",
			value: beginTime.getTime() / 1000
		},
		{
			name: "endTime",
			value: endTime.getTime() / 1000
		},
		{
			name: "userId",
			value: userId
		},
		{
			name: "logType",
			value: logType
		}
	];

	const logs = await apiService.get('log/getLogsByFilters', options);
	return logs;
}
